<template>
  <v-row
    class="mx-5"
    v-if="report !== 'Relatórios'"
  >
    <v-col
      cols="12"
      md="2"
    >
      <v-text-field
        v-mask="['##/##/####']"
        label="Data inicial *"
        placeholder="DD/MM/AAAA"
        :rules="[rules.date]"
        single-line
        type="tel"
        outlined
        rounded
        dense
        hide-details
        :value="filter.initialDate"
        @input="onFilter({initialDate: $event})"
      />
    </v-col>
    <v-col
      cols="12"
      md="2"
    >
      <v-text-field
        v-mask="['##/##/####']"
        label="Data final *"
        placeholder="DD/MM/AAAA"
        :rules="[rules.date]"
        single-line
        type="tel"
        outlined
        rounded
        dense
        hide-details
        :value="filter.endDate"
        @input="onFilter({endDate: $event})"
      />
    </v-col>
    <v-col
      cols="12"
      md="2"
    >
      <v-select
        label="Acervo"
        dense
        :items="tipoPublicacoes"
        :value="filter.idTipopublicacao"
        @input="onFilter({idTipopublicacao: $event})"
        hide-details
        item-text="tipoPublicacao"
        item-value="idTipopublicacao"
        outlined
        clearable
        rounded
      ></v-select>
    </v-col>
    <v-col
      cols="12"
      md="2"
    >
      <v-select
        :items="segmentos"
        :value="filter.idSegmento"
        dense
        hide-details
        outlined
        clearable
        label="Área"
        item-text="segmento"
        item-value="id"
        rounded
        @input="onFilter({idSegmento: $event})"
      ></v-select>
    </v-col>
    <v-col
      cols="12"
      md="4"
      class="text-right"
    >
      <v-btn
        color="accent"
        rounded
        @click="generateReport(report)"
      >
        GERAR RELATÓRIO
      </v-btn>
    </v-col>
  </v-row>
</template>
<script>
import formRules from '@/mixins/form-rules';

export default {
  mixins: [formRules],
  props: {
    onFilter: {
      type: Function,
      default: () => {},
    },
    generateReport: {
      type: Function,
      default: () => {},
    },
    report: {
      type: String,
      default: '',
    },
    filter: {
      type: Object,
      default: () => {},
    },
    tipoPublicacoes: {
      type: Array,
      default: () => [],
    },
    segmentos: {
      type: Array,
      default: () => [],
    },
  },
};
</script>
